// React
import React from 'react';
import { useTranslation } from 'react-i18next';
// FHIR
import { scheduleCategory, FhirCategory } from '../../../utils/ScheduleCategory';
// CSS
import './SchedulePanel.css';

/**
 * Calendar legend.
 */
const ScheduleCategoryPanel: React.FC = () => {
  const { t } = useTranslation();

  return (
    <aside className="calendar-legend" aria-label={t('legend.panel')}>
      <h2>{t('legend.panel')}</h2>
      <ul className="category-list">
        {scheduleCategory.map((category: FhirCategory) => (
          <li key={category.code}>
            <span
              className="category-color-box"
              style={{ backgroundColor: category.color }}
            />
            <span>{t(category.displayKey)}</span>
          </li>
        ))}
      </ul>
    </aside>
  );
};

export default ScheduleCategoryPanel;
